module.exports = __webpack_public_path__ + "img/sergeant-reason-icon10.4103f692.png";